
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/halcyon",
      function () {
        return require("private-next-pages/halcyon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/halcyon"])
      });
    }
  